import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';

import { IErknmFormAgreementTerminate } from '../interfaces/IErknmFormAgreementTerminate';

export const getAgreementTerminateValidate = (terminate: IErknmFormAgreementTerminate, isSupervisor: boolean) => {
  return {
    terminationReasons: terminate.terminationReasons?.map(i => makeRequired(REQUIRED_ERROR)(i)),
    decisionTerminationAttachment: makeRequired(REQUIRED_ERROR)(terminate.decisionTerminationAttachment),
    fioSigner: makeRequired(REQUIRED_ERROR)(terminate.fioSigner),
    titleSigner: isSupervisor
      ? makeRequired(REQUIRED_ERROR)(terminate.titleSigner)
      : {
          label: makeRequired(REQUIRED_ERROR)(terminate.titleSigner?.label),
        },
  };
};
